/* eslint-disable react/prop-types */
import React from 'react'
import styled, { css } from 'styled-components'
import shortid from 'shortid'

import DropdownIcon from '../../static/images/arrow-down-black.svg'

const noop = () => {}

// prettier-ignore
/** @param {{ alertDash?: boolean }} props */
const alertDashStyles = ({ value, alertDash }) =>
  ((alertDash && value === '-')
    ? css`box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);`
    : css``)

export const Dropdown = {
  Container: styled.div`
    width: min-content;
    position: relative;

    &::after {
      content: '';
      width: 20px;
      height: 20px;

      position: absolute;
      z-index: 1;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);

      background-image: url(${DropdownIcon});
      background-repeat: no-repeat;
      background-size: 13px;
      background-position: 50% 60%;
    }
  `,
  Display: styled.select`
    appearance: none; /* remove browser default's style */

    width: 145px;
    height: 30px;
    padding-left: 16px;
    padding-right: 32px;

    position: relative;
    z-index: 2;

    background-color: transparent;
    color: #333333;
    font-family: 'Gotham-Medium';
    font-size: 13px;
    line-height: 31px;

    border-radius: 4px;
    border: 1px solid #e6e6e6;
    outline: none;

    ${alertDashStyles}
  `,
}

/**
 * @param {object} props
 * @param {{ value: string, label: string }[]} [props.options]
 * @param {string} [props.value]
 * @param {(value: string) => void} [props.onChange]
 * @param {boolean} [props.alertDash]
 */
function NativeDropdown({
  value,
  alertDash,
  onChange = noop,
  options = [{ value: '-', label: '-' }],
}) {
  /** @param {React.ChangeEvent<HTMLSelectElement>} e */
  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <Dropdown.Container>
      <Dropdown.Display
        alertDash={ alertDash }
        value={ value || options[0].value }
        onChange={ handleChange }
      >
        {options.map(o => (
          <option key={ shortid.generate() } value={ o.value }>
            {o.label}
          </option>
        ))}
      </Dropdown.Display>
    </Dropdown.Container>
  )
}

export default NativeDropdown



// WEBPACK FOOTER //
// ./src/lib/components/NativeDropdown.jsx